import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { IBreadcrumb } from "../../../../model/interface/breadcrumb";
import { IPermissionGroup } from "../../../../model/interface/permissionGroup";
import { IPermissionGroupAccess } from "../../../../model/interface/permissionGroupAccess";
import Breadcrumb from "../../../shared/common/breadcrumb";
import {
  getPermissionGroupById,
  postPermissionGroup,
  updatePermissionGroup,
  postPermissionGroupAccess,
  updatePermissionGroupAccess,
  getAllPermissionGroupAccess,
} from "../../../../api/permissionGroup.service";
import Constant from "../../../../utils/constant";
import { FilterIcon, ResetIcon } from "../../../../assets/icons/index";
import Loader from "../../../shared/loader/loader";
import SelectPageSize from "../../../shared/common/pageSizeDropdown";
import Pagination from "../../../shared/common/pagination";
import { IPermission } from "../../../../model/interface/permission";
import AllowedTo from "../../../shared/common/rbac";
import pagePermissions from "../../../../utils/permissions";
import AccessDenied from "../../../shared/common/accessDenied";
import { useNumericParam } from "../../../../utils/useNumericParam";

const ManagePermissionGroup = () => {
  const id = useNumericParam("id");
  const defaualtPermissionAccess: IPermissionGroupAccess = {
    permissionGroupAccessId: 0,
    permissionGroupId: id ? id : 0,
    permissionId: 0,
    name: "",
    view: false,
    create: false,
    modify: false,
    delete: false,
  };

  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const [groupName, setgroupName] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [permissionGroupToEditId] = useState<string>(id?.toString() || "");
  const [loading, setLoading] = useState<boolean>(false);

  const [sortDes, setSortDes] = useState<any>(false);
  const [orderByColumn, setOrderByColumn] = useState("Name");
  const [permissions, setPermissions] = useState<IPermission[]>([]);
  const [groups, setGroups] = useState<IPermissionGroup[]>([]);
  const [permissionAccessList, setPermissionAccessList] = useState<
    IPermissionGroupAccess[]
  >([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [nameFilter, setNameFilter] = useState<string>("");

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Permission Groups", url: Constant.PERMISSION_GROUPS },
      {
        name: id ? "Edit Permission Group" : "Add Permission Group",
        url: "",
      },
    ];

    if (id) {
      items.push({ name: id?.toString(), url: "" });
    }
    return items;
  };

  const handlegroupName = (e) => {
    setgroupName(e.target.value);
  };

  const handleNameFilterChange = (e) => {
    setNameFilter(e.target.value);
  };

  const handleSavePermissionGroup = () => {
    if (groupName === "") {
      toast.warning("Required fields cannot be blank");
    } else {
      if (id) {
        updatePermissionGroup({
          permissionGroupId: id,
          name: groupName,
        }).then((group) => {
          if (group.data === -1) {
            toast.warning("Please use unique group name");
          } else if (group.data >= 0) {
            toast.success("Group Permission Access Updated");
          }
        });
      } else {
        postPermissionGroup({ permissionGroupId: 0, name: groupName }).then(
          (group) => {
            if (group.data === -1) {
              toast.warning("Please use unique group name");
            } else if (group.data >= 0) {
              navigate(
                Constant.EDIT_PERMISSION_GROUP.replace(
                  ":id",
                  group.data.toString()
                )
              );
            }
          }
        );
      }
    }
  };

  const handleEditPermissionGroup = async () => {
    if (permissionGroupToEditId !== undefined) {
      setLoading(true);
      const response = getPermissionGroupById(
        parseInt(permissionGroupToEditId)
      );
      const data = (await response).data;
      setLoading(false);

      setgroupName(data?.name);
    }
  };

  useEffect(() => {
    if (id) {
      handleEditPermissionGroup();
    }
  }, [id]);

  useEffect(() => {
    if (isLoaded) {
      handleFilterChanage();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      handleFilterChanage();

      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const handleSortBy = (column: string) => {
    setSortDes(!sortDes);
    setOrderByColumn(column);
  };

  const handleFilterChanage = (reset?: boolean) => {
    if (id) {
      getAllPermissionGroupAccess(
        id,
        reset ? "" : nameFilter,
        orderByColumn,
        sortDes ? "Des" : "Asc",
        reset ? defaultPageSize : pageSize,
        reset ? defaultPageNumber : pageNumber
      ).then((res) => {
        setPermissionAccessList(res.data.data);
        setTotalPages(Math.ceil(res.data.totalRecords / pageSize));
        setTotalRecords(res.data.totalRecords);
      });
    }
  };

  const handleReset = () => {
    setNameFilter("");
    setPermissions([]);
    setGroups([]);
    handleFilterChanage(true);
  };

  const saveGroupAccessPermission = (
    permissionGroupAccess: IPermissionGroupAccess,
    e: any,
    permissionType: string,
    index: number
  ) => {
    setLoading(true);

    const permissionGroupAccessObject: IPermissionGroupAccess = {
      permissionGroupAccessId: permissionGroupAccess.permissionGroupAccessId,
      permissionGroupId: parseInt(permissionGroupToEditId),
      permissionId: permissionGroupAccess.permissionId,
      view:
        permissionType === "VIEW"
          ? e.target.checked
          : permissionGroupAccess.view,
      create:
        permissionType === "CREATE"
          ? e.target.checked
          : permissionGroupAccess.create,
      modify:
        permissionType === "MODIFY"
          ? e.target.checked
          : permissionGroupAccess.modify,
      delete:
        permissionType === "DELETE"
          ? e.target.checked
          : permissionGroupAccess.delete,
      upgrade:
        permissionType === "UPGRADE"
          ? e.target.checked
          : permissionGroupAccess.upgrade,
    };

    if (
      permissionGroupAccessObject.create ||
      permissionGroupAccessObject.delete ||
      permissionGroupAccessObject.modify
    ) {
      permissionGroupAccessObject.view = true;
    }

    if (permissionType === "VIEW" && !e.target.checked) {
      permissionGroupAccessObject.create = false;
      permissionGroupAccessObject.modify = false;
      permissionGroupAccessObject.delete = false;
      permissionGroupAccessObject.view = false;
    }

    if (permissionGroupAccessObject.permissionGroupAccessId) {
      updatePermissionGroupAccess(permissionGroupAccessObject)
        .then((res) => {
          handleFilterChanage();
          toast.success("Group Permission Access Updated");
          setLoading(false);
        })
        .catch((err) => {
          toast.error("Group Permission Access Update failed !!");
          setLoading(false);
        });
    } else {
      postPermissionGroupAccess(permissionGroupAccessObject)
        .then((res) => {
          handleFilterChanage();
          toast.success("Group Permission Access Added");
          setLoading(false);
        })
        .catch((err) => {
          toast.error("Group Permission Access Add failed !!");
          setLoading(false);
        });
    }
  };

  return (
    <AllowedTo
      perform={[
        pagePermissions.permission_groups_create,
        pagePermissions.permission_groups_modify,
      ]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-2">
              <h3 className="text-lg font-light text-gray-900">
                Permission Group
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />

            <div className="flex">
              <form className="w-2/5 mr-14">
                <div className="shadow py-6 border rounded-lg mt-4 px-6">
                  <div className="grid grid-cols-1 mt-2">
                    <div>
                      <label className="text-sm font-medium text-gray-700">
                        Permission Group Name
                      </label>

                      <div>
                        <input
                          id="groupName"
                          name="groupName"
                          type="text"
                          autoComplete="off"
                          value={groupName}
                          onChange={handlegroupName}
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        />
                        {groupName === "" && errorMessage === true && (
                          <span className="text-red-700 inline-block pt-1 text-sm">
                            Group Name is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end mt-8 items-center border-t">
                    <button
                      type="button"
                      onClick={handleSavePermissionGroup}
                      className=" inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      {id ? "Update" : "Save"}
                    </button>
                    <Link to={Constant.PERMISSION_GROUPS} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </form>
              {permissionGroupToEditId ? (
                <div className="pt-6 border-b pb-6 w-3/5">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-4">
                      <label className="text-sm text-gray-700">
                        Permission Name
                      </label>
                      <div className="mt-1 text-sm">
                        <input
                          name="nameFilter"
                          value={nameFilter}
                          placeholder="Search ..."
                          type="text"
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          onChange={(e) => {
                            handleNameFilterChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-start mt-8 items-center border-t ">
                    <button
                      onClick={() => {
                        handleFilterChanage();
                      }}
                      className="inline-flex mr-3 items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                      type="button"
                    >
                      <FilterIcon className="w-3 h-3"></FilterIcon>
                      <span className="ml-2">Filter</span>
                    </button>

                    <button
                      type="button"
                      onClick={() => handleReset()}
                      className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      <ResetIcon className="w-3 h-3"></ResetIcon>
                      <span className="ml-2">Reset Filter</span>
                    </button>
                  </div>
                  <div id="dataContainer" className="mt-4">
                    <div className="flex flex-col mt-1">
                      <div className="-my-2  sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="shadow border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full">
                              <thead>
                                <tr className="bg-gray-50">
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-left text-gray-500 font-semibold tracking-wider"
                                  >
                                    <span className="flex gap-2">
                                      Permission Name
                                    </span>
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-center text-gray-500 font-semibold tracking-wider"
                                  >
                                    View
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-center text-gray-500 font-semibold tracking-wider"
                                  >
                                    Create
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-center text-gray-500 font-semibold tracking-wider"
                                  >
                                    Modify
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-center text-gray-500 font-semibold tracking-wider"
                                  >
                                    Delete
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 text-xs  text-center text-gray-500 font-semibold tracking-wider"
                                  >
                                    Upgrade Required
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y">
                                {permissionAccessList.map(
                                  (permission, index) => (
                                    <tr key={index} className={"bg-white"}>
                                      <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                        {permission.name}
                                      </td>
                                      <td className="px-3 py-2 text-sm text-start font-normal text-gray-500">
                                        <div className="flex justify-center">
                                          <input
                                            onChange={(e) => {
                                              saveGroupAccessPermission(
                                                permission,
                                                e,
                                                "VIEW",
                                                index
                                              );
                                            }}
                                            name="viewAccess"
                                            type="checkbox"
                                            className="cursor-pointer"
                                            checked={permission.view}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-3 py-2 text-sm text-start font-normal text-gray-500">
                                        <div className="flex justify-center">
                                          <input
                                            onChange={(e) => {
                                              saveGroupAccessPermission(
                                                permission,
                                                e,
                                                "CREATE",
                                                index
                                              );
                                            }}
                                            name="createAccess"
                                            type="checkbox"
                                            className="cursor-pointer"
                                            checked={permission.create}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-3 py-2 text-sm text-start font-normal text-gray-500">
                                        <div className="flex justify-center">
                                          <input
                                            onChange={(e) => {
                                              saveGroupAccessPermission(
                                                permission,
                                                e,
                                                "MODIFY",
                                                index
                                              );
                                            }}
                                            name="modifyAccess"
                                            type="checkbox"
                                            className="cursor-pointer"
                                            checked={permission.modify}
                                          />
                                        </div>
                                      </td>
                                      <td className="px-3 py-2 text-sm text-start font-normal text-gray-500">
                                        <div className="flex justify-center">
                                          <input
                                            onChange={(e) => {
                                              saveGroupAccessPermission(
                                                permission,
                                                e,
                                                "DELETE",
                                                index
                                              );
                                            }}
                                            name="deleteAccess"
                                            className="cursor-pointer"
                                            type="checkbox"
                                            checked={permission.delete}
                                          />
                                        </div>
                                      </td>

                                      <td className="px-3 py-2 text-sm text-start font-normal text-gray-500">
                                        <div className="flex justify-center">
                                          <input
                                            onChange={(e) => {
                                              saveGroupAccessPermission(
                                                permission,
                                                e,
                                                "UPGRADE",
                                                index
                                              );
                                            }}
                                            name="upgradeAccess"
                                            className="cursor-pointer"
                                            type="checkbox"
                                            checked={permission.upgrade}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                            <div className="flex justify-between items-center px-2">
                              {permissionAccessList.length ||
                              groups.length !== 0 ? (
                                <>
                                  <Pagination
                                    pages={totalPages}
                                    setPageNumber={setPageNumber}
                                    ref={paginationRef}
                                  />
                                  <span>
                                    <span className="text-sm pr-4 ml-auto text-left-700">
                                      Showing {pageNumber} to{" "}
                                      {totalRecords < pageSize
                                        ? totalRecords
                                        : pageSize}{" "}
                                      of {totalRecords} results
                                    </span>

                                    <SelectPageSize
                                      setPageSize={setPageSize}
                                      type={"second"}
                                      ref={pageSizeRef}
                                    />
                                  </span>
                                </>
                              ) : (
                                <p className="p-2"></p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManagePermissionGroup);
